import React from 'react';
import './App.css';

import Header from './Header';
import Routes from './Routes';

import Amplify, {Auth} from 'aws-amplify';
import aws_exports from '../auth-config';
import {withRouter} from 'react-router';
import AWS from 'aws-sdk';
import ErrorBoundary from './ErrorBoundary';
import {UserContext} from './user/user-context';
import {connect} from 'react-redux';
import {logout} from './utils/actions';

Amplify.configure(aws_exports);
AWS.config.update({ region: 'us-east-1'});

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      userInfo: null,
      user: null
    };
  }

  setUser = (user) => {
    this.setState({ user });
  };

  appAuth = async () => {
    let session,
        authenticated = true,
        loginParams = { IdentityPoolId: aws_exports.Auth.identityPoolId };
    try {
      session = await Auth.currentSession();
    } catch (e) {
      if(e === 'No current user') {
        authenticated = false;
      } else {
        console.error(e);
      }
    } finally {
      if (authenticated) {
        Object.assign(loginParams, { Logins: {
            [`cognito-idp.${aws_exports.Auth.region}.amazonaws.com/${aws_exports.Auth.userPoolId}`]:
            session.idToken.jwtToken
          }
        });
      }
      AWS.config.credentials = new AWS.CognitoIdentityCredentials(loginParams);

      const getCreds = new Promise((resolve, reject) => {
        AWS.config.credentials.get(function (err){
          if (err) {
            console.error(err);
            reject();
          }
          resolve();
        });
      });

      let userInfo;

      try {
        await getCreds;
        if (authenticated) {
          userInfo = await Auth.currentUserInfo();
        }
      } catch (authE) {
        console.error(authE);
        this.setState({ isAuthenticating: false });
        return;
      }

      this.setState({ isAuthenticating: false, isAuthenticated: authenticated, userInfo, jwt: authenticated ? session.idToken.jwtToken : undefined });
    }
  };

  async componentDidMount() {
    await this.appAuth();
  }

  userHasAuthenticated = async authenticated => {
    let userInfo = null;
    if (authenticated) {
      userInfo = await Auth.currentUserInfo();
    }

    this.setState({ isAuthenticated: authenticated, userInfo });
  };

  handleLogout = async () => {
    try {
      await Auth.signOut();
      this.props.dispatch(logout());
      this.userHasAuthenticated(false);

      this.props.history.push('/login');
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    if (this.state.isAuthenticating) {
      return null;
    }

    const authProps = {
      userHasAuthenticated: this.userHasAuthenticated,
      isAuthenticated: this.state.isAuthenticated,
      jwt: this.state.jwt,
      userInfo: this.state.userInfo,
      authenticate: this.appAuth,
      setUser: this.setUser
    };

    return (
      <div className="App">
        <Header auth={authProps} handleLogout={this.handleLogout}/>
        <UserContext.Provider value={{ user: this.state.user }}>
          <ErrorBoundary>
            <Routes childProps={authProps}/>
          </ErrorBoundary>
        </UserContext.Provider>
      </div>
    );
  }
}

export default withRouter(connect()(App));



// WEBPACK FOOTER //
// ./src/components/App.js